module.exports = __webpack_public_path__ + "img/img9.e6eaa086.svg";